export default {
  SET_LANG(state, locale) {
    if (state.options.includes(locale)) {
      state.current = locale;
      this.app.i18n.locale = locale;
      this.commit('_core/user/SET_LANG', locale);
    }
  },
  SET_DEFAULT_LANG(state, locale) {
    if (state.options.includes(locale)) {
      state.default = locale;
    }
  }
};
